(function(){
  var NS='http://www.w3.org/2000/svg';
  var METAL={'#D9A93B':['#F7E7A8','#C08A22'],'#B9BFC6':['#F2F5F7','#8A939C']};

  function chain(svg,tira,cy,r,dur){
    while(svg.firstChild) svg.removeChild(svg.firstChild);
    var cols=(tira.c&&tira.c.length)?tira.c:['#141210'];
    var g=cols.length===1?METAL[cols[0].toUpperCase()]:null;
    var gid='acg_'+svg.id;
    if(g){
      var defs=document.createElementNS(NS,'defs');
      var lg=document.createElementNS(NS,'linearGradient');
      lg.setAttribute('id',gid);lg.setAttribute('x1','0');lg.setAttribute('y1','0');lg.setAttribute('x2','0');lg.setAttribute('y2','1');
      [[0,g[0]],[0.5,cols[0]],[1,g[1]]].forEach(function(st){var sp=document.createElementNS(NS,'stop');sp.setAttribute('offset',st[0]);sp.setAttribute('stop-color',st[1]);lg.appendChild(sp);});
      defs.appendChild(lg);svg.appendChild(defs);
    }
    var cx=200,seg=cols.length===2?6:1,idx=0;
    [[46,-16],[354,-16]].forEach(function(p,li){
      var x0=p[0],y0=p[1],qx=li===0?112:288,qy=cy*0.64,N=42;
      for(var i=0;i<=N;i++){
        var t=i/N,mt=1-t;
        var x=mt*mt*x0+2*mt*t*qx+t*t*cx;
        var y=mt*mt*y0+2*mt*t*qy+t*t*cy;
        var c=document.createElementNS(NS,'circle');
        c.setAttribute('cx',x.toFixed(1));c.setAttribute('cy',y.toFixed(1));c.setAttribute('r',r);
        c.setAttribute('fill',g?'url(#'+gid+')':cols[Math.floor(idx/seg)%cols.length]);
        c.setAttribute('stroke','rgba(20,18,16,.18)');c.setAttribute('stroke-width','.8');
        c.style.opacity=0;svg.appendChild(c);
        (function(el,d){setTimeout(function(){el.style.transition='opacity .22s';el.style.opacity=1;},d);})(c,dur*i+li*(dur*4));
        idx++;
      }
    });
  }

  function swBg(t){
    var c=(t.c&&t.c.length)?t.c:['#141210'];
    var g=c.length===1?METAL[c[0].toUpperCase()]:null;
    if(g) return 'linear-gradient(150deg,'+g[0]+' 0%,'+c[0]+' 50%,'+g[1]+' 100%)';
    if(c.length===2) return 'linear-gradient(135deg,'+c[0]+' 0 50%,'+c[1]+' 50% 100%)';
    return c[0];
  }
  function money(cents){ return '$'+Math.round(cents/100).toLocaleString('es-CO'); }
  function leer(id){ var e=document.getElementById(id); if(!e) return null; try{return JSON.parse(e.textContent);}catch(err){return null;} }

  /* ── ARMADOR ── */
  var D=leer('acData');
  if(D && D.dijes && D.dijes.length && D.tiras && D.tiras.length){
    var DIJES=D.dijes, TIRAS=D.tiras, NIV=D.niveles||{};
    var iD=0,iC=0,hov=null,bolsa=0;
    var svg=document.getElementById('acSvg'),dije=document.getElementById('acDije');
    var img=document.getElementById('acDijeImg'),ph=document.getElementById('acPh');
    var canvas=document.getElementById('acCanvas'),badge=document.getElementById('acBadge');
    var ring=document.getElementById('acRing'),grid=document.getElementById('acGrid');
    var sw=document.getElementById('acSw'),cta=document.getElementById('acCta');

    function nivel(d){ return NIV[(d.nv||'sencillo').toLowerCase()] || NIV['sencillo'] || {v:0,p:0}; }
    function act(){ return DIJES[hov!==null?hov:iD]; }
    function draw(){ chain(svg,TIRAS[iC],282,4.9,7); }
    function pop(){ if(!dije) return; dije.classList.remove('pop'); void dije.offsetWidth; dije.classList.add('pop'); }
    function set(id,v){ var e=document.getElementById(id); if(e) e.textContent=v; }
    function paint(){
      var d=act(),t=TIRAS[iC],n=nivel(d);
      if(d.img){ if(img){img.src=d.img;img.alt=d.n;} if(dije)dije.style.display=''; if(ph)ph.style.display='none'; }
      else { if(dije)dije.style.display='none'; if(ph)ph.style.display='grid'; }
      set('acNombre',d.n); set('acCadenaNm','Tira '+t.n.toLowerCase());
      set('acPrecio',money(n.p)); set('acRs1',d.n); set('acRs1p',money(n.p));
      set('acRs2',t.n.toLowerCase()); set('acSwName',t.n.toLowerCase()); set('acTot',money(n.p));
      if(cta) cta.disabled=false;
    }
    DIJES.forEach(function(d,i){
      var b=document.createElement('button');
      b.type='button'; b.className='ac-ch'+(i===0?' on':'');
      var vis = d.img ? '<img src="'+d.img+'" alt="'+d.n+'">' : '<span class="ph">+</span>';
      b.innerHTML='<span class="tick">&#10003;</span>'+vis+'<span class="lb">'+d.n+'</span>';
      b.onmouseenter=function(){ if(i!==iD){hov=i;paint();} };
      b.onmouseleave=function(){ if(hov!==null){hov=null;paint();} };
      b.onclick=function(){
        grid.querySelectorAll('.ac-ch').forEach(function(x){x.classList.remove('on');});
        b.classList.add('on'); iD=i; hov=null; paint(); pop();
      };
      grid.appendChild(b);
    });
    TIRAS.forEach(function(t,i){
      var b=document.createElement('button');
      b.type='button'; b.className='ac-swb'+(i===0?' on':'');
      b.innerHTML='<i style="background:'+swBg(t)+'"></i><span class="tip">'+t.n+'</span>';
      b.onclick=function(){
        sw.querySelectorAll('.ac-swb').forEach(function(x){x.classList.remove('on');});
        b.classList.add('on'); iC=i; draw(); paint();
      };
      sw.appendChild(b);
    });
    function chispas(){
      var cols=['#E23B2E','#F5C445','#4FA8DE','#EE5C9B','#7FB94E','#C9A0DC'];
      for(var i=0;i<18;i++){
        var s=document.createElement('span');
        s.className='ac-spark'; s.textContent='✦'; s.style.color=cols[i%cols.length];
        s.style.left=(46+Math.random()*8)+'%'; s.style.top=(56+Math.random()*8)+'%';
        s.style.setProperty('--dx',(Math.random()*180-90).toFixed(0)+'px');
        s.style.setProperty('--dy',(Math.random()*-130-20).toFixed(0)+'px');
        canvas.appendChild(s);
        (function(el){setTimeout(function(){el.remove();},950);})(s);
      }
    }
    if(cta) cta.onclick=function(){
      var d=DIJES[iD],t=TIRAS[iC],n=nivel(d);
      if(!n.v){ cta.textContent='Falta configurar el producto'; setTimeout(function(){cta.textContent='Agregar a la bolsa';},2200); return; }
      chispas();
      if(ring){ring.classList.remove('go');void ring.offsetWidth;ring.classList.add('go');}
      pop();
      cta.disabled=true; cta.textContent='Agregando…';
      var props={'Dije':d.n,'Tira':t.n};
      if(d.img) props['_img']=d.img;
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({items:[{id:n.v,quantity:1,properties:props}]})
      }).then(function(r){return r.json();}).then(function(){
        bolsa++; if(badge){badge.textContent=bolsa+' en tu bolsa';badge.classList.add('on');}
        cta.textContent='✓ Agregado a la bolsa'; cta.classList.add('ok');
        if(typeof window.visosOpenCart==='function') window.visosOpenCart();
        setTimeout(function(){cta.textContent='Agregar a la bolsa';cta.classList.remove('ok');cta.disabled=false;},1600);
      }).catch(function(){
        cta.textContent='No se pudo agregar'; cta.disabled=false;
        setTimeout(function(){cta.textContent='Agregar a la bolsa';},1800);
      });
    };
    draw(); paint();
  }

  /* ── BANNER ── */
  var B=leer('acbData');
  var bsvg=document.getElementById('acbSvg');
  if(B && bsvg && B.dijes && B.dijes.length && B.tiras && B.tiras.length){
    var BD=B.dijes,BT=B.tiras,bi=0,bc=0,tm=null;
    var bim=document.getElementById('acbImg'),bdj=document.getElementById('acbDije');
    var bph=document.getElementById('acbPh'),bsw=document.getElementById('acbSw');
    function bdraw(){ chain(bsvg,BT[bc],210,5.6,6); }
    function bset(i){
      bi=i; var d=BD[bi];
      if(d.img){ if(bim){bim.src=d.img;bim.alt=d.n;} if(bdj)bdj.style.display=''; if(bph)bph.style.display='none'; }
      else { if(bdj)bdj.style.display='none'; if(bph)bph.style.display='grid'; }
      if(bdj){bdj.classList.remove('pop');void bdj.offsetWidth;bdj.classList.add('pop');}
    }
    function bauto(){ if(BD.length>1) tm=setInterval(function(){bset((bi+1)%BD.length);},2600); }
    BT.slice(0,8).forEach(function(t,i){
      var b=document.createElement('button');
      b.type='button'; b.className=i===0?'on':''; b.title=t.n;
      b.innerHTML='<i style="background:'+swBg(t)+'"></i>';
      b.onclick=function(){
        bsw.querySelectorAll('button').forEach(function(x){x.classList.remove('on');});
        b.classList.add('on'); bc=i; bdraw();
      };
      bsw.appendChild(b);
    });
    if(BT.length>8){ var m=document.createElement('span'); m.className='more'; m.textContent='+'+(BT.length-8)+' colores más'; bsw.appendChild(m); }
    var view=bsvg.parentNode;
    view.addEventListener('mouseenter',function(){clearInterval(tm);});
    view.addEventListener('mouseleave',bauto);
    bdraw(); bset(0); bauto();
  }
})();
